<style scoped lang="scss">
  .payment-success-page {
    @include padding-y(40px);
    display: flex;
    flex-direction: column;
    align-items: center;

    .message-icon {
      .icon {
        height: 60px;
        width: 60px;
      }
    }

    .message-text {
      margin-top: 30px;
      text-align: center;

      .title-text {
        font-weight: 500;
        font-size: 16px;
      }

      .info-text {
        margin-top: 10px;
      }
    }
  }
</style>

<template>
  <div class="payment-success-page">
    <div class="message-icon">
      <icon name="check-circle" theme gradient :inline="false"/>
    </div>
    <div class="message-text">
      <div class="title-text">{{ $t('success.thanks') }}</div>
      <div class="info-text">{{ $t('success.donationComplete') }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PaymentSuccessPage',
  created() {
    this.$emit('load')
  },
}
</script>
